import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { hasTouchEvents } from '../../../shared/util';
import MenuLogin from './menu-login';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.user != this.props.user) {
            return true;
        }

        return false;
    }

    render({ user }) {
        return (
            <user-menu>
                {user.logged_in ? this.renderLoggedIn() : <MenuLogin />}
            </user-menu>
        );
    }

    renderLoggedIn = () => {
        return (
            <div className='user-li'>
                <ul className='user-li-header'>
                    {this.renderMyAccount()}
                </ul>
                <ul className='user-li-nav'>
                    <li className='ub-karmacoins'>
                        <a
                            href='/store/karma-coins'
                            data-label='My Account - Karma Coins© Balance'
                            onClick={this.trackClick}
                        >
                            <span />
                            <div className='account-details'>
                                <h5>Karma Coins Store</h5>
                                <p>You Have {this.props.user.kcs.total.toLocaleString()} Karma Coins</p>
                            </div>
                        </a>
                    </li>
                    <li className='ub-journal'>
                        <a
                            href='/member/journal'
                            data-label='My Journal'
                            onClick={this.trackClick}
                        >
                            <span />
                            <div className='account-details'>
                                <h5>Your Readings</h5>
                                <p>View Your Readings Journal</p>
                            </div>
                        </a>
                    </li>
                    {this.renderVIPLink()}
                    <li className='ub-wheel'>
                        <a
                            href='/readings-reports/astrology-reports/your-birth-chart'
                            data-label='My Account - Birth Chart'
                            onClick={this.trackClick}
                        >
                            <span />
                            <div className='your-birth-chart'>
                                <h5>Your Birth Chart</h5>
                                <p>View Your Personal Astrology</p>
                            </div>
                        </a>
                    </li>
                    <li className='ub-settings'>
                        <a
                            href='/member/settings'
                            data-label='My Account - Settings'
                            onClick={this.trackClick}
                        >
                            <span />
                            <div className='account-details'>
                                <h5>Account Settings</h5>
                                <p>Set Your Favorite Tarot Deck</p>
                            </div>
                        </a>
                    </li>
                    <li className='ub-logout'>
                        <a href='#logout' data-label='Log Out' onClick={this.trackClick}>
                            <span />
                            <div className='account-details'>
                                <h5>Log Out</h5>
                            </div>
                        </a>
                    </li>
                </ul>
            </div>
        );
    }

    renderMyAccount = () => {
        const avatar = this.props.user.avatar_url || 'https://gfx.tarot.com/images/site/tarot/ui/avatar-unknown.jpg';

        if (hasTouchEvents) {
            return (
                <li className='my-account'>
                    <div className='avatar-mask'>
                        <img src={avatar} height='40' width='40' className='avatar' alt='User profile picture' />
                    </div>
                    <div className='account-details'>
                        <h5>My Account</h5>
                        <p>{this.props.user.kcs.total.toLocaleString()} Karma Coins<sup>®</sup></p>
                    </div>
                </li>
            );
        }

        return (
            <li className='my-account'>
                <a href='/member/settings' data-label='My Account - Karma Coins®' onClick={this.trackClick}>
                    <div className='avatar-mask'>
                        <img src={avatar} height='40' width='40' alt='User profile picture' className='avatar' />
                    </div>
                    <div className='account-details'>
                        <h5>My Account</h5>
                        <p>{this.props.user.kcs.total.toLocaleString()} Karma Coins<sup>®</sup></p>
                    </div>
                </a>
            </li>
        );
    }

    renderVIPLink = () => {
        let href = '/readings-reports/subscription/vip-membership';
        let text = 'Try Our Vip Membership';

        if (
            this.props.user
            &&
            this.props.user.subscriptions
            &&
            this.props.user.subscriptions.vip
        ) {
            href = '/vip/daily-horoscope';
            text = 'My Vip Membership';
        }

        return (
            <li className='ub-vip'>
                <a href={href} data-label='VIP' onClick={this.trackClick}>
                    <span />
                    <div className='account-details'>
                        <h5 dangerouslySetInnerHTML={{__html: text}} />
                        <p>Your Unique Horoscopes</p>
                    </div>
                </a>
            </li>
        );
    }

    trackClick = (e) => {
        const category = 'Navigation';
        const action = this.props.user.logged_in ? 'LI Click' : 'LO Click';
        const label = e.currentTarget.dataset.label;

        this.props.trackEvent([category, action, label]);
        this.props.trackPromo([category, label]);
    };
}

const mapStateToProps = (state) => ({
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    trackPromo: (payload) => dispatch({ type: 'promo-tracker:recordInternal', payload: payload }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
